import { Component, OnInit } from '@angular/core';
import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Message } from 'src/app/models/message';
import { MessageService } from 'primeng/components/common/messageservice'
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  userform: FormGroup;
  url: string = "https://formspree.io/xvowgvwg";
  message: Message;
  constructor(private titleService: Title, private fb: FormBuilder, private httpClient: HttpClient, private messageService: MessageService) {}

  ngOnInit() {
    this.titleService.setTitle("Lejdi Prifti - Contact");
    this.message = {};
    this.initializeForm();
    this.loadScript();
  }

  initializeForm(): void {
    this.userform = this.fb.group({
      'firstName': new FormControl('', Validators.required),
      'lastName': new FormControl('', Validators.required),
      'email': new FormControl('', [ 
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$")
      ]),
      'message': new FormControl('', Validators.required)
  });
  }

  loadScript() {
    let body = <HTMLDivElement> document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://widgets.fiverr.com/api/v1/seller/lejdi_prifti?widget_id=baa90e74-11fd-428f-857d-a4b52a4a36e1';
    script.async = true;
    script.defer = true;
    script.id = 'fiverr-seller-widget-script-baa90e74-11fd-428f-857d-a4b52a4a36e1';
    script.setAttribute('data-config', '{"category_name":"Programming \u0026 Tech"}')
    body.appendChild(script);
}

  send(): void {
    const options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    this.message.firstName = this.userform.get('firstName').value;
    this.message.lastName = this.userform.get('lastName').value;
    this.message.email = this.userform.get('email').value;
    this.message.message = this.userform.get('message').value;
    this.httpClient.post<void>(this.url, JSON.stringify({
      name: this.message.firstName + " " + this.message.lastName,
      email: this.message.email,
      message: this.message.message
    }), options).subscribe(res=>{
      this.messageService.add({severity: 'success', summary: 'Success', detail: 'Message sent successfully!'});
    }, err=>{
      this.messageService.add({severity: 'error', summary: 'Error', detail: 'Message could not be sent!'});
    });
    this.reset();
  }

  reset(): void {
    this.initializeForm();
  }
}
